import * as ProgressIcon from "../../../src/Components/ProgressIcon/ProgressIcon.scss";
import { Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, int32_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { int32ToString } from "../../fable_modules/fable-library.3.7.20/Util.js";
import * as react from "react";
import { Size, getMaterialIconBySize } from "../../ViewUtils.js";


export class SectionState extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Done", "Active", "Inactive"];
    }
}

export function SectionState$reflection() {
    return union_type("Components.ProgressIcon.SectionState", [], SectionState, () => [[], [["Item", int32_type]], [["Item", int32_type]]]);
}

export function getProgressIcon(iconState) {
    let children_4, children_8, children;
    switch (iconState.tag) {
        case 1: {
            const children_6 = [(children_4 = [int32ToString(iconState.fields[0])], react.createElement("span", {
                className: "container__icon container__icon--active",
            }, ...children_4))];
            return react.createElement("div", {
                className: "progress-icon__container",
            }, ...children_6);
        }
        case 2: {
            const children_10 = [(children_8 = [int32ToString(iconState.fields[0])], react.createElement("span", {
                className: "container__icon container__icon--inactive",
            }, ...children_8))];
            return react.createElement("div", {
                className: "progress-icon__container",
            }, ...children_10);
        }
        default: {
            const children_2 = [(children = [getMaterialIconBySize("done", new Size(2))], react.createElement("span", {
                className: "container__icon container__icon--checkbox",
            }, ...children))];
            return react.createElement("div", {
                className: "progress-icon__container",
            }, ...children_2);
        }
    }
}

